<div class="modal-header">
  <div class="title">
    <h2 class="modal-title-prefix"><span translate="BENEFICIRANI.SINGULAR"></span></h2>
    <h1 class="modal-title">
      <span *ngIf="baseUpdate.Item.ID <= 0"><span translate="BENEFICIRANI.NEW"></span></span>
      <span *ngIf="baseUpdate.Item.ID > 0"><span>{{baseUpdate.Item.Naziv}}</span></span>
    </h1>
  </div>
  <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-body">
  <yt-beneficirani-update #baseUpdate></yt-beneficirani-update>
</div>
<div class="modal-footer">
  <button type="submit" class="btn btn-primary" (click)="Save()" id="btnSave"><span>Sačuvaj</span></button>
  <button type="button" class="btn btn-secondary" (click)="Close()" id="btnClose"><span>Zatvori</span></button>
</div>